/**
 * Portal Manta · Card1Qualitativo
 * Extraído de App.jsx (v29 modular)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { M, F, STATUS } from '../../tokens/theme.js';
import { UFS_BR } from '../../data/ufs-br.js';

const Card1Qualitativo = memo(function Card1Qualitativo_Inner({qual, setQ, onChangeUF}){
  const inputStl = {
    width:'100%', padding:'7px 10px', border:`1px solid ${M.border}`, borderRadius:4,
    fontFamily:F.body, fontSize:11.5, color:M.text, outline:'none', background:'#fff',
  };
  const labelStl = {
    fontSize:9.5, fontWeight:700, color:M.muted, letterSpacing:.5, marginBottom:5,
    textTransform:'uppercase', fontFamily:F.body,
  };
  const fieldGap = 10;

  return (<div>
    {/* Linha 1 · Identificação · 4 campos */}
    <div style={{fontSize:10, fontWeight:700, color:M.accent, letterSpacing:.5, textTransform:'uppercase', marginBottom:8, fontFamily:F.mono}}>
      1.1 · Identificação
    </div>
    <div style={{display:'grid', gridTemplateColumns:'2fr 1fr 1.5fr 1.5fr', gap:fieldGap, marginBottom:18}}>
      <div>
        <div style={labelStl}>Nome do estudo *</div>
        <input type="text" value={qual.nome} onChange={e=>setQ('nome',e.target.value)}
          placeholder="Ex: BR-101 Sul · estudo paramétrico" style={inputStl}/>
      </div>
      <div>
        <div style={labelStl}>UF *</div>
        <select value={qual.uf} onChange={e=>onChangeUF(e.target.value)} style={{...inputStl, padding:'6px 8px', cursor:'pointer'}}>
          {UFS_BR.map(u => <option key={u} value={u}>{u}</option>)}
        </select>
      </div>
      <div>
        <div style={labelStl}>Cidade / região</div>
        <input type="text" value={qual.cidade} onChange={e=>setQ('cidade',e.target.value)}
          placeholder="Ex: Maringá-Londrina" style={inputStl}/>
      </div>
      <div>
        <div style={labelStl}>Tipo de obra</div>
        <select value={qual.tipoObra} onChange={e=>setQ('tipoObra',e.target.value)} style={{...inputStl, padding:'6px 8px', cursor:'pointer'}}>
          <option value="rodovia-existente">Rodovia existente · ampliação</option>
          <option value="rodovia-greenfield">Rodovia greenfield</option>
          <option value="rodovia-restauracao">Restauração / manutenção</option>
          <option value="duplicacao">Duplicação total</option>
          <option value="contorno">Contorno urbano</option>
        </select>
      </div>
    </div>

    {/* Linha 2 · Contexto qualitativo · 3 sliders + 1 nota */}
    <div style={{fontSize:10, fontWeight:700, color:M.accent, letterSpacing:.5, textTransform:'uppercase', marginBottom:8, fontFamily:F.mono}}>
      1.2 · Contexto do traçado
    </div>
    <div style={{display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:fieldGap, marginBottom:18, padding:'12px 14px', background:M.bgAlt, borderRadius:6}}>
      <div>
        <div style={labelStl}>Rural · {(qual.ctxRural*100).toFixed(0)}%</div>
        <input type="range" min="0" max="1" step="0.05" value={qual.ctxRural} onChange={e=>setQ('ctxRural',parseFloat(e.target.value))} style={{width:'100%'}}/>
      </div>
      <div>
        <div style={labelStl}>Urbano · {(qual.ctxUrbano*100).toFixed(0)}%</div>
        <input type="range" min="0" max="1" step="0.05" value={qual.ctxUrbano} onChange={e=>setQ('ctxUrbano',parseFloat(e.target.value))} style={{width:'100%'}}/>
      </div>
      <div>
        <div style={labelStl}>Serra · {(qual.ctxSerra*100).toFixed(0)}%</div>
        <input type="range" min="0" max="1" step="0.05" value={qual.ctxSerra} onChange={e=>setQ('ctxSerra',parseFloat(e.target.value))} style={{width:'100%'}}/>
      </div>
    </div>

    {/* Linha 3 · Chuva · 3 campos */}
    <div style={{fontSize:10, fontWeight:700, color:M.accent, letterSpacing:.5, textTransform:'uppercase', marginBottom:8, fontFamily:F.mono, display:'flex', alignItems:'baseline', gap:8}}>
      <span>1.3 · Regime de chuvas</span>
      <span style={{fontSize:9, color:M.muted, fontStyle:'italic', textTransform:'none', letterSpacing:0, fontFamily:F.body}}>(autopreenchido por UF · pode editar)</span>
    </div>
    <div style={{display:'grid', gridTemplateColumns:'1fr 1fr 1fr 1fr', gap:fieldGap, marginBottom:18}}>
      <div>
        <div style={labelStl}>Precipitação (mm/ano)</div>
        <input type="number" value={qual.chuvaMM} onChange={e=>setQ('chuvaMM',parseFloat(e.target.value)||0)} style={{...inputStl, fontFamily:F.mono}}/>
      </div>
      <div>
        <div style={labelStl}>Dias chuvosos</div>
        <input type="number" value={qual.chuvaDias} onChange={e=>setQ('chuvaDias',parseFloat(e.target.value)||0)} style={{...inputStl, fontFamily:F.mono}}/>
      </div>
      <div>
        <div style={labelStl}>Regime</div>
        <select value={qual.chuvaRegime} onChange={e=>setQ('chuvaRegime',e.target.value)} style={{...inputStl, padding:'6px 8px', cursor:'pointer'}}>
          <option>Regular</option><option>Sazonal seco</option><option>Sazonal úmido</option><option>Equatorial</option>
        </select>
      </div>
      <div style={{padding:'8px 10px', background:M.bgAlt, borderRadius:5, border:`1px solid ${M.borderSoft}`}}>
        <div style={{fontSize:8.5, fontWeight:700, color:M.muted, letterSpacing:.3, textTransform:'uppercase'}}>Trabalháveis/ano</div>
        <div style={{fontSize:14, fontWeight:800, color:M.green, fontFamily:F.mono}}>{Math.round(365 - qual.chuvaDias*0.7)}</div>
        <div style={{fontSize:8.5, color:M.muted, fontStyle:'italic'}}>fator {((1-qual.chuvaDias/365)*100).toFixed(0)}%</div>
      </div>
    </div>

    {/* Linha 4 · Notas livres */}
    <div style={{fontSize:10, fontWeight:700, color:M.accent, letterSpacing:.5, textTransform:'uppercase', marginBottom:8, fontFamily:F.mono}}>
      1.4 · Notas qualitativas (opcional)
    </div>
    <div>
      <textarea value={qual.notas} onChange={e=>setQ('notas',e.target.value)} rows={2}
        placeholder="Ex: travessia urbana de Maringá no km 200 · 2 viadutos sobre ferrovia · pista dupla com canteiro central existente"
        style={{...inputStl, resize:'vertical', minHeight:48}}/>
    </div>
  </div>);
});

export { Card1Qualitativo };
export default Card1Qualitativo;
